export * from './BrandDetails';
